import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import React, { createElement, memo } from 'react';
import clsx from 'clsx';

function FilterRow(_ref) {
  var columns = _ref.columns,
      lastFrozenColumnIndex = _ref.lastFrozenColumnIndex,
      filters = _ref.filters,
      onFiltersChange = _ref.onFiltersChange;

  function _onChange(key, value) {
    var newFilters = Object.assign({}, filters);
    newFilters[key] = value;
    onFiltersChange === null || onFiltersChange === void 0 ? void 0 : onFiltersChange(newFilters);
  }

  return /*#__PURE__*/React.createElement("div", {
    role: "row",
    "aria-rowindex": 2,
    className: "rdg-filter-row"
  }, columns.map(function (column) {
    var key = column.key;
    var className = clsx('rdg-cell', {
      'rdg-cell-frozen': column.frozen,
      'rdg-cell-frozen-last': column.idx === lastFrozenColumnIndex
    });
    var style = {
      width: column.width,
      left: column.left
    };
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      style: style,
      className: className
    }, column.filterRenderer && /*#__PURE__*/createElement(column.filterRenderer, {
      column: column,
      value: filters === null || filters === void 0 ? void 0 : filters[column.key],
      onChange: function onChange(value) {
        return _onChange(key, value);
      }
    }));
  }));
}

export default /*#__PURE__*/memo(FilterRow);